import { agingBucket, dueDateOf, saldoPendiente } from './cobranzas';

export const WHATSAPP_AGING_BUCKETS = [
  { id: 'vigente', label: 'A vencer' },
  { id: '1-30', label: '1–30 días vencida' },
  { id: '31-60', label: '31–60 días vencida' },
  { id: '61+', label: '61+ días vencida' },
];

export const WHATSAPP_TEMPLATE_VARS = [
  'cliente',
  'numero',
  'saldo',
  'moneda',
  'vencimiento',
  'empresa',
  'alias',
  'cbu',
  'link',
];

export const DEFAULT_WHATSAPP_TEMPLATES = {
  vigente: 'Hola {{cliente}}, te escribo por el registro #{{numero}} de {{moneda}} {{saldo}}. Vence el {{vencimiento}}. ¿Podemos coordinar el pago?',
  '1-30': 'Hola {{cliente}}, te recordamos el saldo pendiente del registro #{{numero}}: {{moneda}} {{saldo}}. ¿Podemos coordinar el pago esta semana?',
  '31-60': 'Hola {{cliente}}, el registro #{{numero}} lleva más de un mes pendiente ({{moneda}} {{saldo}}). Necesitamos regularizar el pago.',
  '61+': 'Hola {{cliente}}, el registro #{{numero}} sigue impago por {{moneda}} {{saldo}}. Por favor contactanos para cerrar la deuda.',
};

export function normalizeWhatsappTemplates(raw = {}) {
  const out = { ...DEFAULT_WHATSAPP_TEMPLATES };
  for (const bucket of WHATSAPP_AGING_BUCKETS) {
    const value = String(raw?.[bucket.id] ?? '').trim();
    if (value) out[bucket.id] = value.slice(0, 500);
  }
  return out;
}

export function renderWhatsappTemplate(template, vars = {}) {
  return String(template || '').replace(/\{\{(\w+)\}\}/g, (_, key) => String(vars[key] ?? ''));
}

export function buildWhatsappTemplateVars(factura, options = {}) {
  const saldo = saldoPendiente(factura);
  const moneda = factura?.moneda || 'ARS';
  const saldoTxt = saldo
    ? Number(saldo).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '';
  const venc = dueDateOf(factura);
  const paymentLines = [];
  if (options.paymentAlias) paymentLines.push(`Alias: ${options.paymentAlias}`);
  if (options.paymentCbu) paymentLines.push(`CBU: ${options.paymentCbu}`);
  if (options.paymentLink) paymentLines.push(`Link: ${options.paymentLink}`);

  return {
    cliente: factura?.razonSocial || factura?.cliente || '',
    numero: factura?.numero ? String(factura.numero) : '',
    saldo: saldoTxt,
    moneda,
    vencimiento: venc ? String(venc).slice(0, 10) : '',
    empresa: options.empresa || 'Contsuite',
    alias: options.paymentAlias || '',
    cbu: options.paymentCbu || '',
    link: options.paymentLink || '',
    pagos: paymentLines.join(' · '),
  };
}

export function whatsappOptionsFromPrefs(prefs, user) {
  if (!prefs) return { empresa: user?.company || 'Contsuite' };
  return {
    templates: prefs.whatsappTemplates,
    paymentAlias: prefs.paymentAlias,
    paymentCbu: prefs.paymentCbu,
    paymentLink: prefs.paymentLink,
    empresa: user?.company || 'Contsuite',
  };
}

export function cobranzaWhatsappText(factura, options = {}) {
  const bucket = agingBucket(factura) || 'vigente';
  const templates = normalizeWhatsappTemplates(options.templates);
  const template = templates[bucket] || templates.vigente;
  const vars = buildWhatsappTemplateVars(factura, options);
  let text = renderWhatsappTemplate(template, vars).trim();

  const extras = [];
  if (vars.alias) extras.push(`Alias: ${vars.alias}`);
  if (vars.cbu) extras.push(`CBU: ${vars.cbu}`);
  if (vars.link) extras.push(`Link: ${vars.link}`);
  if (extras.length && !/\{\{alias\}\}|\{\{cbu\}\}|\{\{link\}\}/.test(template)) {
    text = `${text}\n\nDatos para pagar:\n${extras.join('\n')}`;
  }

  return text;
}
